<template lang="pug">
.study-result-resolve-list
  //- ヘッダー部
  .study-result-resolve-list__header
    button-return.study-result-resolve-list__header__button(@click='moveReturnEvent')
      slot(name='returnButtonText')
    text-frame.study-result-resolve-list__header__title.text-large
      .study-result-resolve-list__header__title__value {{ resultDetailTitle }}
      .study-result-resolve-list__header__title__label
        slot(name='titleLabel')
  //- キャプチャ画像一覧
  study-result-detail-image-list.study-result-resolve-list__images(:images='images', :clickEvent='imageClickEvent')
  //- 一覧表示
  .study-result-resolve-list__list-wrapper
    study-result-resolve-table.study-result-resolve-list__list(
      :studyResultResolves='studyResultResolves',
      :retryEachButtonEvent='retryEachButtonEvent'
    )
      template(#problemNumberHeader)
        slot(name='problemNumberHeader')
      template(#questionNumberHeader)
        slot(name='questionNumberHeader')
      template(#questionTypeHeader)
        slot(name='questionTypeHeader')
      template(#correctAnswerHeader)
        slot(name='correctAnswerHeader')
      template(#correctSymbolHeader)
        slot(name='correctSymbolHeader')
      template(#resolveCorrectSymbolHeader)
        slot(name='resolveCorrectSymbolHeader')
      template(#retryHeader)
        slot(name='retryHeader')
      template(#retryEachButtonText)
        slot(name='retryEachButtonText')
    //- 再挑戦ボタン
    .study-result-resolve-list__action
      button-primary.study-result-resolve-list__action__button(v-if='showRetryButton', @click='retryButtonEvent')
        slot(name='retryButtonText')
  //- モーダル部
  modal-show-image.study-result-resolve-list__modal(:imageUrl='imageUrl', ref='modalShowImage')
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import ButtonReturn from '@/components/molecules/student/ButtonReturn.vue'
import TextFrame from '@/components/atoms/TextFrame.vue'
import StudyResultDetailImageList from '@/components/organisms/student/StudyResultDetailImageList.vue'
import StudyResultResolveTable from '@/components/organisms/student/StudyResultResolveTable.vue'
import ButtonPrimary from '@/components/molecules/student/ButtonPrimary.vue'
import ModalShowImage from '@/components/organisms/student/ModalShowImage.vue'
import { StudyResultDetailImage, StudyResultResolveType } from '@/models/studyResultDetailModel'

/**
 * テスト結果解きなおし画面テンプレート
 */
@Component({
  components: {
    ButtonReturn,
    TextFrame,
    StudyResultDetailImageList,
    StudyResultResolveTable,
    ButtonPrimary,
    ModalShowImage,
  },
})
export default class StudyResultResolveList extends Vue {
  // 戻るボタン押下時イベント
  @Prop()
  moveReturnEvent!: Function

  // 画面タイトル
  @Prop()
  resultDetailTitle!: string

  // キャプチャ画像一覧情報
  @Prop()
  images!: StudyResultDetailImage[]

  // テスト結果解きなおし詳細表示情報
  @Prop()
  studyResultResolves!: StudyResultResolveType[]

  // 再挑戦ボタン表示フラグ
  @Prop()
  showRetryButton!: boolean

  // 再挑戦ボタン押下時イベント
  @Prop()
  retryButtonEvent!: Function

  // 項目毎の解きなおすボタン押下時イベント
  @Prop()
  retryEachButtonEvent!: Function

  // モーダルのRef
  @Ref() modalShowImage!: ModalShowImage

  // モーダルに表示する画像
  private imageUrl = ''

  // キャプチャ画像クリック時イベント
  private imageClickEvent(image: StudyResultDetailImage) {
    // 選択された画像URLをセット
    this.imageUrl = image.imageUrl
    // モーダルを開く
    if (this.imageUrl) {
      this.modalShowImage.show()
    }
  }
}
</script>

<style lang="stylus" scoped>
.study-result-resolve-list
  padding 20px
  display flex
  height 95vh
  width 100%
  flex-direction column

  &__list-wrapper
    overflow-y auto
    min-height 0

  &__header
    display flex
    align-items center
    margin-bottom 10px

    &__button
      width 180px
      margin-right 10px

    &__title
      width 100%
      display flex
      justify-content center
      padding 20px
      background-color var(--color-default__box-background)

      &__label
        margin-left 5px

  &__images
    margin-bottom 10px
    max-width 100%
    overflow-x auto
    flex-shrink 0

  &__list
    margin-bottom 10px

  &__action
    display flex
    justify-content center
    padding 10px

    &__button
      width 180px
</style>
